exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadow[data-v-6eb9ac3f]{box-shadow:0 0 18px 0 rgba(0,0,0,.15)!important}.go-back[data-v-6eb9ac3f]{margin-bottom:50px}@media (min-width:1280px){.go-back[data-v-6eb9ac3f]{margin-bottom:60px}}.go-back span[data-v-6eb9ac3f]{font-size:16px;color:#9b9b9b;transition:color .2s ease}.go-back[data-v-6eb9ac3f]:hover{text-decoration:none}.go-back:hover span[data-v-6eb9ac3f]{color:#72fb27}", ""]);

// exports
